import api from "@/app/api";
import { ExportButton } from "@/app/components/ExportButton";
import Private from "@/app/components/Private";
import TablePage from "@/app/components/TablePage";
import { ApiContext } from "@/app/contexts/ApiContext";
import { Sponsorship } from "@/app/sponsorships/types";

export default function Sponsorships() {
  return (
    <ApiContext.Provider
      value={{
        listData: api.getSponsorships,
        getFieldOptions: api.getSponsorshipFieldOptions,
        getData: api.getSponsorship,
        getFields: api.getSponsorshipFields,
        updateEntry: api.updateSponsorship,
        deleteEntry: api.deleteSponsorship,
        createEntry: api.createSponsorship,
        createFieldOption: api.createSponsorshipFieldOption,
      }}
    >
      <Private>
        <TablePage<Sponsorship>
          className="sponsorships"
          searchPlaceholder="Search by property or sponsor..."
          exportBtn={(selected) => <ExportButton sponsorships={selected} />}
        />
      </Private>
    </ApiContext.Provider>
  );
}
